import { render, staticRenderFns } from "./prodNotice.vue?vue&type=template&id=2f4beea8&scoped=true&"
import script from "./prodNotice.vue?vue&type=script&lang=js&"
export * from "./prodNotice.vue?vue&type=script&lang=js&"
import style0 from "./prodNotice.vue?vue&type=style&index=0&id=2f4beea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4beea8",
  null
  
)

export default component.exports